export enum PaymentResponseStatus {
  SUCCEEDED = 'succeeded',
}

export interface StripePaymentIntentPostResponse {
  id: string;
  object: string;
  amount: number;
  amount_capturable: number;
  amount_received: number;
  application: string | null;
  application_fee_amount: number | null;
  automatic_payment_methods: string | null;
  canceled_at: number | null;
  cancellation_reason: string | null;
  capture_method: string;
  charges: {
    object: string;
    data: string[];
    has_more: boolean;
    total_count: number;
    url: string;
  };
  client_secret: string;
  confirmation_method: string;
  created: number;
  currency: string;
  customer: string | null;
  description: string;
  invoice: string | null;
  last_payment_error: string | null;
  latest_charge: string | null;
  livemode: boolean;
  metadata: string[];
  next_action: string | null;
  on_behalf_of: string | null;
  payment_method: string | null;
  payment_method_configuration_details: string | null;
  payment_method_options: {
    card: {
      installments: object | null;
      mandate_options: object | null;
      network: string | null;
      request_three_d_secure: string;
    }
  };
  payment_method_types: string[];
  processing: string | null;
  receipt_email: string | null;
  review: string | null;
  setup_future_usage: string | null;
  shipping: string | null;
  source: string | null;
  statement_descriptor: string | null;
  statement_descriptor_suffix: string | null;
  status: string;
  transfer_data: string | null;
  transfer_group: string | null;
}

export interface StripeAfterPaymentResponse {
  error?: {
    message: string;
  };
  paymentIntent?: StripePaymentResponseIntent;
}

export interface StripePaymentResponseIntent {
  status: PaymentResponseStatus.SUCCEEDED;
  id: string;
}
